import {
	IForgotPasswordConfirm,
	IForgotPasswordGetVerificationCode,
	ILogin,
} from "../../model/custom/IAuth";

export class AuthUserLoginAction {
	static readonly type = "[Auth] User Login";

	constructor(public payload: ILogin) {}
}

export class AuthForgotPasswordRequestVerificationCodeAction {
	static readonly type = "[Auth] Forgot Password Request Verification Code";

	constructor(public payload: IForgotPasswordGetVerificationCode) {}
}

export class AuthForgotPasswordConfirmAction {
	static readonly type = "[Auth] Forgot Password Confirm";

	constructor(public payload: IForgotPasswordConfirm) {}
}

export class AuthRedirectBasedOnRoleAction {
	static readonly type = "[Auth] Redirect Based On Role";
}

export class AuthRedirectToLoginAction {
	static readonly type = "[Auth] Redirect To Login";
}

export class AuthRegisterCompanyAction {
	static readonly type = "[Auth] Register Company";
}
export class AuthRegisterClearErrorsAction {
	static readonly type = "[Auth] Clear Errors";
}

export class LoginSms2Fa {
	static readonly type = "[Auth] Login Sms 2Fa";
	constructor(public payload: { code: string }) {}
}
